export const AUTH_COOKIE_NAMES = ['myToken', 'myName', 'myUserId', 'myCategory', 'mySuperuser'];
// Auto logout after this much inactivity (30–45 min range; using 45 min).
export const IDLE_TIMEOUT_MS = 45 * 60 * 1000;

const SESSION_FLAG_KEY = 'rmcAuthSession';
const LAST_ACTIVITY_KEY = 'rmcLastActivity';
export const SESSION_EXPIRED_FLAG_KEY = 'rmcSessionExpiredNotice';

function readSession(key) {
  try {
    return sessionStorage.getItem(key);
  } catch (e) {
    return null;
  }
}

function writeSession(key, value) {
  try {
    sessionStorage.setItem(key, value);
  } catch (e) {
    // sessionStorage unavailable
  }
}

function removeSession(key) {
  try {
    sessionStorage.removeItem(key);
  } catch (e) {
    // ignore
  }
}

export function markSessionActive() {
  writeSession(SESSION_FLAG_KEY, '1');
  writeSession(LAST_ACTIVITY_KEY, String(Date.now()));
  removeSession(SESSION_EXPIRED_FLAG_KEY);
}

export function touchSessionActivity() {
  if (readSession(SESSION_FLAG_KEY) === '1') {
    writeSession(LAST_ACTIVITY_KEY, String(Date.now()));
  }
}

function getLastActivity() {
  return Number(readSession(LAST_ACTIVITY_KEY) || 0);
}

export function hasBrowserSession() {
  return readSession(SESSION_FLAG_KEY) === '1';
}

export function isIdleExpired() {
  if (!hasBrowserSession()) {
    return false;
  }
  const lastActivity = getLastActivity();
  if (!lastActivity) {
    return false;
  }
  return (Date.now() - lastActivity) >= IDLE_TIMEOUT_MS;
}

export function isAuthenticated(cookies) {
  if (!cookies?.myToken) {
    return false;
  }
  if (!hasBrowserSession()) {
    return false;
  }
  return !isIdleExpired();
}

export function markSessionExpiredNotice() {
  writeSession(SESSION_EXPIRED_FLAG_KEY, '1');
}

export function consumeSessionExpiredNotice() {
  try {
    if (sessionStorage.getItem(SESSION_EXPIRED_FLAG_KEY) === '1') {
      sessionStorage.removeItem(SESSION_EXPIRED_FLAG_KEY);
      return true;
    }
  } catch (e) {
    // ignore
  }
  return false;
}

export function clearBrowserSession() {
  removeSession(SESSION_FLAG_KEY);
  removeSession(LAST_ACTIVITY_KEY);
}

export function clearAuthCookiesDocument() {
  AUTH_COOKIE_NAMES.forEach((name) => {
    document.cookie = `${name}=; Max-Age=0; path=/`;
  });
}

export const SESSION_EXPIRED_MESSAGE =
  'This session has been automatically expired due to inactivity. Please login again.';
